import { PureComponent } from 'react';
import { downloadLog, taskerClear } from '../../actions';

import { List } from 'immutable';
import {
  makeSelectDownloadingLogKeys,
  makeSelectMessagesTasker,
} from 'pages/SnapshotManagement/selectors';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import Terminal from './Terminal';

class Tasker extends PureComponent {
  static propTypes = {
    msg: PropTypes.object.isRequired,
    onDownloadLog: PropTypes.func.isRequired,
    onTaskerClear: PropTypes.func.isRequired,
    tasker: PropTypes.instanceOf(List),
    downloadingLogKeys: ImmutablePropTypes.list.isRequired,
  };

  render() {
    const { msg, onTaskerClear, tasker, onDownloadLog, downloadingLogKeys } =
      this.props;
    return (
      <Terminal
        btnClearTitle={msg.btnClearTitle}
        defaultCountRows={20}
        divClass='col-xl-6 col-xs-12'
        downloadLogKey='tasker'
        heightPx={250}
        label={msg.tasker}
        messagesList={tasker}
        msg={msg}
        onClear={onTaskerClear}
        onDownloadLog={onDownloadLog}
        downloading={downloadingLogKeys.includes('tasker')}
      />
    );
  }
}

const mapStateToProps = createStructuredSelector({
  tasker: makeSelectMessagesTasker(),
  downloadingLogKeys: makeSelectDownloadingLogKeys(),
});

function mapDispatchToProps(dispatch) {
  return {
    onDownloadLog: (args) => dispatch(downloadLog(args)),
    onTaskerClear: () => dispatch(taskerClear()),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Tasker);
